// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"a9ae05df","110":"1a5b5685","140":"36e5fdbc","243":"d002869e","271":"6d5028d6","406":"5362531d","422":"d780d36b","453":"c9161952","619":"944cd990","624":"c099a23a","784":"a805402d","826":"ca42b1bc","841":"824c9879"}[chunkId] + ".chunk.js";
};